import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconArrowUpStyle0 = cosmosIconCss;

const CosmosIconArrowUp$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconArrowUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'f7235f95080e7dbbdf42abeb5c33d166d511519c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '98f773316387183ca721a45c67d09a7092df1bd4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'ede9932dff8866fe7f92521270afda92e2a1963e', d: "m11.746 6.72 3.146 3.145a.5.5 0 0 0 .707 0l.353-.353a.5.5 0 0 0 0-.707l-4.596-4.597a.499.499 0 0 0-.357-.146.498.498 0 0 0-.356.146L6.046 8.805a.5.5 0 0 0 0 .707l.354.353a.5.5 0 0 0 .707 0l3.14-3.139v10.718a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V6.72Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconArrowUpStyle0; }
}, [1, "cosmos-icon-arrow-up", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-arrow-up"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-arrow-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconArrowUp$1);
            }
            break;
    } });
}

const CosmosIconArrowUp = CosmosIconArrowUp$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconArrowUp, defineCustomElement };
